import type { BookingSiteSetupStatus, UseLegacyBookingSiteSetupStatusArgs } from './use-booking-site-setup-status';
import { useGetIsAppointmentTypeMappedWithPractitioner } from './use-get-is-appointment-type-mapped-with-practitioner';
import { useGetIsScheduleDefinitionConfigured } from './use-get-is-schedule-definition-configured';

export const useLegacyBookingSiteSetupStatus = ({
  enabled,
  isScheduleDefinitionsEnabled,
}: UseLegacyBookingSiteSetupStatusArgs): BookingSiteSetupStatus => {
  const {
    hasAnyLocationMapping,
    locationWiseMappingStatus,
    isLoading: isLoadingAppointmentTypeMapping,
  } = useGetIsAppointmentTypeMappedWithPractitioner(enabled && !isScheduleDefinitionsEnabled);

  const {
    hasAnyScheduleDefinition,
    locationWiseScheduleDefinitionStatus,
    isLoading: isLoadingScheduleDefinition,
  } = useGetIsScheduleDefinitionConfigured(enabled && isScheduleDefinitionsEnabled);

  const locationWiseIsSetupMap = isScheduleDefinitionsEnabled
    ? locationWiseScheduleDefinitionStatus
    : locationWiseMappingStatus;

  const hasAnyLocationSetup = isScheduleDefinitionsEnabled ? hasAnyScheduleDefinition : hasAnyLocationMapping;

  return {
    isLoading: enabled
      ? isScheduleDefinitionsEnabled
        ? isLoadingScheduleDefinition
        : isLoadingAppointmentTypeMapping
      : false,
    hasAnyLocationSetup: enabled ? hasAnyLocationSetup : false,
    isScheduleDefinitionsEnabled,
    reasonCode: undefined,
    locationWiseIsSetupMap: enabled ? locationWiseIsSetupMap : {},
    locationWiseReasonCode: {},
  };
};
